import * as THREE from 'three'

export default abstract class Controls {
  LerpVecWrap (
    vecStart: THREE.Vector3,
    vecEnd: THREE.Vector3,
    vecA: THREE.Vector3,
    vecB: THREE.Vector3,
    targetVec: THREE.Vector3,
    amount: number
  ): THREE.Vector3 {
    targetVec.set(
      this.WrapLerp(vecStart.x, vecEnd.x, vecA.x, vecB.x, amount),
      this.WrapLerp(vecStart.y, vecEnd.y, vecA.y, vecB.y, amount),
      this.WrapLerp(vecStart.z, vecEnd.z, vecA.z, vecB.z, amount)
    )
    return targetVec
  }

  WrapLerp (
    start: number,
    end: number,
    a: number,
    b: number,
    amount: number
  ): number {
    const bActual =
      (b > end)
        ? start + (b - end)
        : (b < start)
            ? end - (start - b)
            : b

    const range = Math.abs(end - start)
    const halfRange = range / 2
    const normDiff = b - a

    const inverseDiff =
      (Math.min(a, bActual) - start) +
      (end - Math.max(a, bActual))

    if (b < end && b > start && halfRange > Math.abs(normDiff)) {
      return a + (normDiff * amount)
    } else {
      if (a < start + halfRange) {
        const newAmount = a - inverseDiff * amount
        return newAmount - (Math.floor((newAmount - start) / range) * range)
      } else {
        // we go the other way
        const newAmount = a + inverseDiff * amount
        return newAmount - (Math.floor((newAmount - start) / range) * range)
      }
    }
  }

  sumVectors (vectors: THREE.Vector3[]): THREE.Vector3 {
    const sumVector = new THREE.Vector3()

    vectors.forEach(v => {
      sumVector.add(v)
    })

    return sumVector
  }
}
